import React, { forwardRef } from "react";
import DefaultInput from "./DefaultInput";
import PasswordInput from "./PasswordInput";
import FileInput from "./FileInput";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  file?: File;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  noBorder?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ errorMessage, type, noBorder, ...args }, ref) => {
    const allProps = { errorMessage, type, noBorder, ...args };

    if (type === "password") {
      return <PasswordInput {...allProps} ref={ref} />;
    } else if (type === "file") {
      return <FileInput {...allProps} ref={ref} />;
    } else {
      return <DefaultInput {...allProps} ref={ref} />;
    }
  },
);

Input.displayName = "Input";

export default Input;
